import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useKioskoStore, useDispenserControls} from 'context/kiosko';
import {PATHS} from 'Routes';
import {usePath} from 'hooks';
import {StyledButton} from './styled';

type Props = {
  onPrintCard: () => void;
};
function PrintKeyCardButton({onPrintCard}: Props) {
  const {t} = useTranslation();
  const pending = useKioskoStore(state => state.cards.pending);
  const isKiosko = useKioskoStore(state => state.connection.isConnected);
  const {printCard} = useDispenserControls();
  const navigate = useNavigate();
  const {getFullPath} = usePath();

  const handleOnClick = () => {
    if (pending > 0) {
      printCard();
      onPrintCard();
    } else {
      navigate(getFullPath(PATHS.remoteKeys));
    }
  };

  if (!isKiosko) {
    return null;
  }

  return (
    <StyledButton
      label={pending > 0 ? t('print_keycard') : t('go_to_keycards')}
      link
      onClick={handleOnClick}
    />
  );
}
export {PrintKeyCardButton};
